export default __webpack_public_path__ + "static/default-c891831842b0759195fe2b9c55f8c8ac.jpg";